// Chakra imports
import {
	Flex,
	Select,
	Button,
	Text,
	HStack,
	Stack,
	SimpleGrid,
	useColorModeValue,
} from "@chakra-ui/react";
// assets
import BarChart from "components/Charts/BarChart";
// Custom icons
import {
	CartIcon,
	DocumentIcon,
	GlobeIcon,
	WalletIcon,
} from "components/Icons/Icons.js";
import { ArrowBackIcon, ChevronDownIcon } from "@chakra-ui/icons";
import React from "react";
import ActiveUsers from "../Dashboard/components/ActiveUsers";
import MiniStatistics from "../Dashboard/components/MiniStatistics";
import Request from "assets/svg/request-icon.svg";
import Success from "assets/svg/success-icon.svg";
import Errors from "assets/svg/errors-icon.svg";
import Usage from "assets/svg/notification-icon.svg";
import Settings from "assets/svg/settings-icon.svg";

function APIDetail() {
	return (
		<Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
			<HStack justify="space-between" mb={5}>
				<Flex align="center" gap={3}>
					<ArrowBackIcon boxSize={6} />
					<Text fontSize="2xl" fontWeight="bold">
						API Name
					</Text>
				</Flex>
				<Flex gap={3}>
					<Stack direction="row" spacing={2}>
						<img src={Usage} />
						<Text fontSize="2xl">Usage Alerts</Text>
					</Stack>
					<Stack direction="row" spacing={2}>
						<img src={Settings} />
						<Text fontSize="2xl">Settings</Text>
					</Stack>
				</Flex>
			</HStack>
			<SimpleGrid columns={{ sm: 1, md: 3, xl: 3 }} spacing="24px">
				<MiniStatistics
					title={"Today's Users"}
					amount={"2,300"}
					percentage={5}
					icon={Request}
				/>
				<MiniStatistics
					title={"New Clients"}
					amount={"+3,020"}
					percentage={-14}
					icon={Success}
				/>
				<MiniStatistics
					title={"Total Sales"}
					amount={"$173,000"}
					percentage={8}
					icon={Errors}
				/>
			</SimpleGrid>
			<Flex>
				<ActiveUsers
					title={"Active Users"}
					percentage={23}
					chart={<BarChart />}
				/>
			</Flex>
		</Flex>
	);
}

export default APIDetail;
